import { render, staticRenderFns } from "./ReportTopicLinks.vue?vue&type=template&id=3fa8bdce&scoped=true"
import script from "./ReportTopicLinks.vue?vue&type=script&lang=js"
export * from "./ReportTopicLinks.vue?vue&type=script&lang=js"
import style0 from "./ReportTopicLinks.vue?vue&type=style&index=0&id=3fa8bdce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8bdce",
  null
  
)

export default component.exports